import { useLayoutEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

// Opts the current page into the LatentForce brand: the brand palette (paper in light
// mode, ink in dark mode, ember accent, Space Grotesk / Poppins / Space Mono). With
// `{ paperOnly: true }` the page is always paper (marketing pages, docs); otherwise it
// follows the brand pages' own theme preference, which defaults to light (auth pages).
// ThemeProvider puts the `lf-theme` class on <html> while a scope is set, so portalled
// overlays (search, modals) pick it up too; the console never sets one. Layout effect,
// so the first paint already has the brand colours.
export default function useBrandTheme({ paperOnly = false } = {}) {
  const { setBrandScope } = useTheme();
  useLayoutEffect(() => {
    setBrandScope(paperOnly ? 'light' : 'pref');
    return () => setBrandScope(false);
  }, [setBrandScope, paperOnly]);
}
